// extracted by mini-css-extract-plugin
export default {"container":"Features_container__Vji0n"};